function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52404",
  "data-name": "Path 52404",
  d: "M0,0H18V18H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52405",
  "data-name": "Path 52405",
  d: "M12,12H3",
  transform: "translate(-0.75 -3)",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52406",
  "data-name": "Path 52406",
  d: "M3.947,12.75a6.75,6.75,0,1,0,0-6",
  transform: "translate(-0.987 -0.75)",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52407",
  "data-name": "Path 52407",
  d: "M12,9l2.25,2.25L12,13.5",
  transform: "translate(-3 -2.25)",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgExitLogOut2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exit-log-out.2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitLogOut2);
export default __webpack_public_path__ + "static/media/exit-log-out.2.87a4c091.svg";
export { ForwardRef as ReactComponent };